<div
  class="choose-adventure-container"
  style="background-image: url(&quot;assets/img/login-background.png&quot;)"
>
  <top-nav [isAdventureView]="true"></top-nav>
  <h1 class="welcome-text main-title centered-text">
    {{ "APP.WELCOME" | translate }}
  </h1>
  <p class="welcome-text sub-title centered-text">
    {{ "APP.WELCOME_SUB_HEADER" | translate }}
  </p>

  <div class="navigation-options-container">
    <mat-card
      appearance="outlined"
      role="navigation"
      class="navigate-option customer-portal"
    >
      <div class="circular-image">
        <img src="assets/img/customer_portal.png" alt="Customer Portal Icon" />
      </div>
      <h2 class="mat-h5 navigation-title">
        {{ "CHOOSE_ADVENTURE.CUSTOMER_PORTAL" | translate }}
      </h2>
      <p class="mat-caption navigation-description">
        {{ "CHOOSE_ADVENTURE.CUSTOMER_PORTAL_DESC" | translate }}
      </p>
      <a class="mat-button link-button" [href]="enterpriseURL">
        {{ "CHOOSE_ADVENTURE.GO_TO_CUSTOMER_PORTAL" | translate }}
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </a>
    </mat-card>
    <mat-card appearance="outlined" role="navigation" class="navigate-option">
      <div class="circular-image">
        <img src="assets/img/member_portal.png" alt="Member Portal Icon" />
      </div>
      <h2 class="mat-h5 navigation-title">
        {{ "CHOOSE_ADVENTURE.MEMBER_PORTAL" | translate }}
      </h2>
      <p class="mat-caption navigation-description">
        {{ "CHOOSE_ADVENTURE.MEMBER_PORTAL_DESC" | translate }}
      </p>
      <a class="mat-button link-button" [href]="memberPortalURL">
        {{ "CHOOSE_ADVENTURE.GO_TO_MEMBER_PORTAL" | translate }}
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </a>
    </mat-card>
  </div>
</div>
